import React from "react";
import { formatDecimal } from "../../../../hooks/Method";

// Configuration for table rows
const tableRowsConfig = (data) => [
  {
    label: "Discount Adjustment (+)",
    value: `$ ${formatDecimal(data.discAdj || 0)}`,
  },
  {
    label: "Total Return Tax (-)",
    value: `$ ${formatDecimal(data.refundTaxAmt || 0)}`,
    style: { borderBottom: "2px solid #ddd" },
  },
  {
    label: "Return Amount",
    value: `$ ${formatDecimal(data.refundAmt || 0)}`,
    isBold: true,
  },
];

const SummaryTable = ({ data }) => {
  if (!data) return null;

  const rows = tableRowsConfig(data);

  return (
    <table
      style={{
        width: "100%",
        marginTop: "15px",
        borderCollapse: "collapse",
        textTransform: "uppercase",
      }}
    >
      <tbody>
        {rows.map((row, index) => (
          <tr key={index} style={{ ...row.style }}>
            <td
              style={{
                color: "#6f6f6f",
                fontSize: "14px",
                paddingBottom: "5px",
                paddingTop: "5px",
                fontWeight: row.isBold ? "bold" : "normal",
              }}
            >
              {row.label}
            </td>
            <td
              style={{
                textAlign: "right",
                color: "#6f6f6f",
                fontSize: row.isBold ? "18px" : "14px",
                fontWeight: row.isBold ? "bold" : "normal",
                paddingBottom: "5px",
                paddingTop: "5px",
              }}
            >
              {row.value}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default React.memo(SummaryTable);
